import React from 'react';
import { motion } from 'framer-motion';
import { Minimize, Activity, Zap, Pill } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-28 md:py-32 bg-white text-slate-900 relative overflow-hidden" data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-174">
        <div className="text-center mb-20 max-w-3xl mx-auto" data-id="element-175">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-slate-900 mb-6" data-id="element-176">
            Wie UroNacht wirkt
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-slate-600 leading-relaxed" data-id="element-177">
            Ein präzise abgestimmtes Protokoll aus sechs Wirkstoffen —
            entwickelt, um die drei Hauptursachen nächtlichen Harndrangs
            gleichzeitig anzugehen.
          </motion.p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-20" data-id="element-178">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-slate-100 z-0" data-id="element-179" />

          {[{
          step: 'Schritt 1',
          icon: Minimize,
          title: 'Prostata-Volumen regulieren',
          text: '640 mg Sägepalmenextrakt und 100 mg Pygeum Africanum hemmen die 5-Alpha-Reduktase — das Enzym, das für die Vergrößerung der Prostata verantwortlich ist. Das Ergebnis: weniger Druck auf die Harnröhre.'
        }, {
          step: 'Schritt 2',
          icon: Activity,
          title: 'Blasenmuskulatur entspannen',
          text: '360 mg Brennnesselblatt und 180 mg Beta-Sitosterol wirken synergistisch auf die glatte Muskulatur der Blase. Sie fördern die vollständige Entleerung und reduzieren den Restharn.'
        }, {
          step: 'Schritt 3',
          icon: Zap,
          title: 'Bioverfügbarkeit maximieren',
          text: 'BioPerine® (Piper Nigrum Extrakt) erhöht die Aufnahme aller Wirkstoffe um bis zu 30%. Lycopin ergänzt als starkes Antioxidans den Zellschutz der Prostata.'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative bg-white p-8 lg:p-10 rounded-2xl shadow-sm border border-slate-200 z-10 flex flex-col items-center text-center group hover:-translate-y-2 transition-transform duration-300 hover:shadow-md" data-id="element-180">
              <div className="w-16 h-16 rounded-full bg-brand-500 text-white flex items-center justify-center mb-6 shadow-lg shadow-brand-900/10 border-4 border-white" data-id="element-181">
                <item.icon className="w-8 h-8" strokeWidth={1.5} data-id="element-182" />
              </div>

              <div className="text-brand-600 font-bold text-xs uppercase tracking-widest mb-3 bg-brand-50 px-3 py-1 rounded-full border border-brand-100" data-id="element-183">
                {item.step}
              </div>

              <h3 className="text-2xl font-serif font-bold text-slate-900 mb-4" data-id="element-184">
                {item.title}
              </h3>

              <p className="text-base text-slate-600 leading-loose" data-id="element-185">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-slate-50 border border-slate-200 rounded-2xl p-8 md:p-10 text-center shadow-sm relative overflow-hidden" data-id="element-186">
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-500" data-id="element-187" />

          <div className="flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-188">
            <div className="w-16 h-16 rounded-full bg-white border border-slate-200 flex items-center justify-center flex-shrink-0" data-id="element-189">
              <Pill className="w-8 h-8 text-brand-500" data-id="element-190" />
            </div>
            <div className="text-left" data-id="element-191">
              <h4 className="text-xl font-bold text-slate-900 mb-2" data-id="element-192">
                Empfohlene Einnahme
              </h4>
              <p className="text-slate-600 text-lg leading-relaxed" data-id="element-193">
                <span className="font-bold text-brand-600 bg-brand-50 px-2 py-0.5 rounded border border-brand-100" data-id="element-194">
                  Tägliche Dosis: 3 Kapseln
                </span>{' '}
                — nehmen Sie alle drei Kapseln zusammen mit einem Glas Wasser
                zum Abendessen ein, um die maximale Wirksamkeit über Nacht zu
                gewährleisten.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}